




























































































import { Component, Vue } from "vue-property-decorator";
import { LibraryGroup } from "@/interfaces";
import { getLibraries } from "@/services";

@Component
export default class LibrariesManagement extends Vue {
  libraries: LibraryGroup[] = [];
  loading = false;
  filteredData: LibraryGroup[] = [];

  searchText = "";

  async mounted() {
    try {
      this.loading = true;
      this.libraries = await getLibraries();
      this.filteredData = this.libraries;
    } catch (error) {
      console.log(error);
    } finally {
      this.loading = false;
    }
  }

  dataSearchSubmit() {
    if (this.searchText.trim() !== "") {
      this.filteredData = this.libraries.filter(term =>
        term.nicename.toLowerCase().includes(this.searchText.toLowerCase()),
      );
    } else {
      this.filteredData = this.libraries;
    }
  }

  openLibraryPage(row: LibraryGroup) {
    this.$router.push(`library-management/${row.name}`).catch(error => console.log(error));
  }

  get columns() {
    return [
      {
        name: "nicename",
        label: "Nome",
        field: "nicename",
        align: "left",
        sortable: true,
      },
      { name: "view", align: "center" },
    ];
  }
}
